<app-layout type="blue">
  <div id="mfa-setup">
    <h1>{{'mfasetup.title' | translate}}</h1>

  <ul>
    <li [class.opened]="isOpened('email')" id="email">
      <div class="tab-title">
        <h5>{{'mfasetup.viaEmail' | translate}}</h5>
        <button (click)="toggleTab('email')">
          <app-icon-chevron-up />
        </button>
      </div>

      <div class="tab-content">
        <p>{{'mfasetup.emailText' | translate}}</p>
      </div>
    </li>

    <li [class.opened]="isOpened('backup')" id="backup">
      <div class="tab-title">
      <h5>{{'mfasetup.viaBackup' | translate}}</h5>
        <button (click)="toggleTab('backup')">
          <app-icon-chevron-up />
        </button>
      </div>

      <div class="tab-content">
        <p>{{'mfasetup.backupText' | translate}}</p>
        <div class="codes">
          <span>29347343</span>
          <span>29347343</span>
          <span>29347343</span>
          <span>29347343</span>
          <span>29347343</span>
          <span>29347343</span>
          <span>29347343</span>
          <span>29347343</span>
          <span>29347343</span>
          <span>29347343</span>
        </div>

        <div class="btn">
        <app-button>
          <button (click)="generateCodes()" type="button" data-testid="mfa-setup-generate-codes">{{'mfasetup.generate' | translate}}</button>
        </app-button>
        </div>
      </div>
    </li>
  </ul>

    <div class="button-group">
      <div class="action">
        <app-button variant="primary">
          <a routerLink="/mfa-setup/add" queryParamsHandling="preserve">
              {{ 'mfasetup.addMethods' | translate }}
          </a>
          </app-button>
      </div>

      <app-button>
          <a routerLink="/" queryParamsHandling="preserve">
              {{ 'mfasetup.back' | translate }}
          </a>
      </app-button>
    </div>

  </div>
</app-layout>
